import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { deleteLocalStorageItem } from "../../helpers/localStorageHelper";
import { LSRegFormData, SessionStorageKeys } from "../../utils/constants";
import { deletesessionStorageItem } from "../../helpers/sessionStorageHelper";

export const RouteListener = () => {
  const location = useLocation();

  useEffect(() => {
    //cleanup local storage on route change
    const currentPath = location.pathname.toLowerCase();
    if (!currentPath.startsWith("/signup")) {
      deleteLocalStorageItem(LSRegFormData);
    }

    //cleanup create profile session
    if (
      currentPath.startsWith("/signup") ||
      currentPath.startsWith("/signin")
    ) {
      deletesessionStorageItem(SessionStorageKeys.CreateProfileId);
    }
  }, []);

  return null;
};
